var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.cardHealth > 0)?_c('div',{staticClass:"card",class:{
        flipped: _vm.looksFlipped,
        unflipped: !_vm.looksFlipped
      },style:({
        'background-color': _vm.looksFlipped ? 'white' : 'grey',
        left: _vm.left + 'px',
        top: _vm.top + 'px',
        transform: 'rotateZ(' + _vm.displayRotation + 'deg) rotateY(' + _vm.yRotation + 'deg)',
        transition: 'transform ' + _vm.flipTimeMs / 2 + 'ms ease-in',
      }),on:{"click":_vm.clicked}},[(_vm.looksFlipped)?[_c('div',[_vm._v("Health: "+_vm._s(_vm.cardHealth))]),_c('div',[_vm._v("Attack: "+_vm._s(_vm.cardAttack))])]:[_vm._v("\n      ?\n    ")]],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }